import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-analytics-widget',
  templateUrl: './analytics-widget.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AnalyticsWidgetComponent {
  @Input() isNoContent: boolean = false;

  @Input() loading: boolean = false;
}
